import { useRedeemFollowInvite as useRedeemFollowInviteApi } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollowInvites } from "./useFollowInvites"
import { useAlerts } from "src/hooks/alerts"
import { useDeviceSettingsList } from "src/hooks/deviceSettings"
import { useFollows } from "src/hooks/follows"

export function useRedeemFollowInvite() {
  const {
    mutate: mutateFollows,
    data: follows,
  } = useFollows()

  const { mutate: mutateFollowInvites } = useFollowInvites()
  const { mutate: mutateAlerts } = useAlerts()
  const { mutate: mutateDeviceSettingsList } = useDeviceSettingsList()

  const redeemFollowInvite = useRedeemFollowInviteApi()

  return useMemo(
    () => !redeemFollowInvite
      ? undefined
      : async (redemptionCode: number) => {
        const response = await redeemFollowInvite({
          redemption_code: redemptionCode,
        })

        const { follow } = response.data

        if (follows) {
          void mutateFollows([
            follow,
            ...follows,
          ])
        } else {
          void mutateFollows()
        }

        void mutateAlerts()
        void mutateDeviceSettingsList()
        void mutateFollowInvites()

        return response
      },
    [
      follows,
      mutateAlerts,
      mutateDeviceSettingsList,
      mutateFollowInvites,
      mutateFollows,
      redeemFollowInvite,
    ],
  )
}

